import React, { useState } from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { DisplayAlignment, DisplaySize, ModalType } from '../../../shared/enum/EnumRepository';
import { WorkDetailData } from '../../../shared/dto/EntityRepository';
import { StyledImgProps } from '../../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../../shared/aws/awsHelper';
import OptimizedMoleculeImg from '../../../shared/component/molecule/OptimizedMoleculeImg';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import fullIcon from '../../../asset/icon/full_image.png';
export interface DetailImgInPeMobileProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  data: WorkDetailData;
  priority: boolean;
}

const DetailImgInPeMobile: React.FC<DetailImgInPeMobileProps> = ({ peId, alignment, displaySize, data, priority }) => {
  const { isEditMode } = useEditMode();
  const handleImageChange = useProjectElementListStore((s) => s.updateImage);
  const { setStandardModal } = useModalStore();
  const [isHovered, setIsHovered] = useState(false);

  const convertedCloudFrontUrl = convertS3UrlToCloudFrontUrl(data.uploadFile.originUrl);

  const showOriginImg = () => {
    setStandardModal({
      modalType: ModalType.ORIGIN_IMG,
      title: `${data.description}`,
      value: convertedCloudFrontUrl,
      handleChange: () => { },
      option: data.uploadFile.allowDownload
    });
  }

  return (
    <ImgInPeWrapper
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
        {!isEditMode && (
          <BtnContainer2 $isHovered={isHovered}>
            <UniversalIconBtn 
              size="fit" 
              border={true} 
              backgroundImg={fullIcon} 
              onClick={showOriginImg} />
          </BtnContainer2>  
        )}
      <OptimizedMoleculeImg
        srcUrl={convertedCloudFrontUrl}
        alt={data.description}
        displaySize={displaySize}
        displayAlignment={alignment || DisplayAlignment.CENTER}
        handleChange={(originUrl: string, width: number, height: number) => handleImageChange(
          peId,
          originUrl,
          width,
          height
        )}
        StyledImg={WorkImageForLandscape as React.ComponentType<StyledImgProps>}
        priority={priority}
      />
    </ImgInPeWrapper>
  );
};

const ImgInPeWrapper = styled.div`
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
`;

const BtnContainer2 = styled.div<{ $isHovered: boolean }>`
  position: absolute;
  right: 0.5vh;
  top: 0.5vh;
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
  opacity: ${({ $isHovered }) => $isHovered ? 1 : 0};
  cursor: ${({ $isHovered }) => $isHovered ? 'pointer' : 'none'};
  pointer-events: ${({ $isHovered }) => $isHovered ? 'auto' : 'none'};
  transition: all 0.3s ease-in-out;
`

const WorkImageForLandscape = styled.img<{ $displaySize: DisplaySize }>`
  width: ${({ $displaySize }) => {
    switch ($displaySize) {
      case DisplaySize.SMALL:
      case DisplaySize.REGULAR:
      case DisplaySize.MEDIUM:
      case DisplaySize.BIG:
        return '90vw';
      case DisplaySize.WIDE:
      default:
        return '100vw';
    }
  }};
  transition: width 0.6s ease;
  object-fit: contain;
`;

export default DetailImgInPeMobile;

